export default __webpack_public_path__ + "static/media/ai.fd3ffd23.svg";